import { useEffect, useState } from 'react';

/**
 * Reveals `text` character by character at `speed` ms per character.
 * Restarts when `text` changes. Returns full text immediately under
 * prefers-reduced-motion.
 */
export function useTypewriter(
  text: string,
  speed: number = 30,
): { displayed: string; done: boolean } {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setDisplayed(text);
      return;
    }

    setDisplayed('');
    if (!text) return;

    let i = 0;
    const id = window.setInterval(() => {
      i += 1;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) {
        window.clearInterval(id);
      }
    }, speed);

    return () => window.clearInterval(id);
  }, [text, speed]);

  return { displayed, done: displayed === text };
}
